// extracted by mini-css-extract-plugin
export default {"dropdownToggle":"EllipsesDropdown_dropdownToggle__ftBot","dropdownMenu":"EllipsesDropdown_dropdownMenu__IxwBZ","moreInfoIcon":"EllipsesDropdown_moreInfoIcon__eXEy1"};